import React from 'react'
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box';
import GrievenceList from './GrievenceList';
import GrievenceRedressal from './GrievenceRedressal';
import { GrievenceRedressalModel } from 'model/screensModels/GrievenceRedressalModel';
import { LocalStorageService } from 'services/auth/LocalStorageService';

const Grievence = () => {
  const [flag, setFlag] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [updateValue, setUpdateValue] = React.useState(new GrievenceRedressalModel());

  useEffect(() => {
    const fetchRole = async () => {
      const role = await LocalStorageService.getUserRole();
      setUserRole(role);
    };
    fetchRole();
  }, []);


  const getViewRecordValue = (grievenceModel: GrievenceRedressalModel) => {
    setIsEditMode(true);
    setUpdateValue(grievenceModel);
  }

  const addGrievence = () => {
    setUpdateValue(new GrievenceRedressalModel())
    setIsEditMode(false); // Reset edit mode
    setFlag(true);
  }

  return (
    <Box sx={{ width: '100%' }} className="container-subheaders container-h-full">
      <Box>

        <div className="content-subheader">
          {!flag ? (
            <h2 className="mr-3 font-weight-bolder">Grievance Redressal List</h2>
          ) : (
            <h2 className="mr-3">{isEditMode ? 'Edit Grievance Redressal' : 'Add Grievance Redressal'}</h2>
          )}
          {!flag && userRole?.toLowerCase() === 'member' && (
            <button className="btn primary" onClick={addGrievence}>
              Add Grievance Redressal
            </button>
          )}


        </div>
      </Box>
      {!flag ?
        <div className='sub-content-sec recently-blog'>
          <GrievenceList setFlag={setFlag} updateRecord={getViewRecordValue} />
        </div>
        :
        <GrievenceRedressal setFlag={setFlag} updateRecord={updateValue} />
      }
    </Box>
  )
}

export default Grievence
